import axios from 'axios'
export const api = axios.create();
api.interceptors.request.use(function (config) {
    config.baseURL = process.env.REPORT_URL ;
    return config
})

export default api


// WEBPACK FOOTER //
// ./src/api/reportsAPI.js